import { forwardRef } from "react"
import { mergeClasses } from "@lib/css"

import type { IconProps } from "./types"

export const IconLikes = forwardRef<SVGSVGElement, IconProps>(
  function IconLikes(props, ref) {
    const { className, title, titleId, ...otherProps } = props
    const defaultClasses =
      "w-8 h-8 flex-shrink-0 text-white transition-colors duration-150 ease-in focus:outline-none"
    const classes = mergeClasses(defaultClasses, className)

    return (
      <svg
        ref={ref}
        viewBox="0 0 32 32"
        fill="none"
        focusable="false"
        aria-hidden="true"
        tabIndex={-1}
        className={classes}
        aria-labelledby={titleId}
        {...otherProps}
      >
        {title ? <title id={titleId}>{title}</title> : null}
        <path
          d="M16.256 32C16.0512 32 15.8464 31.8974 15.744 31.7949C13.901 29.8462 11.8532 28.1026 9.90785 26.359C5.30034 22.5641 1 18.8718 1 13.2308C1 7.69231 4.17406 4 9.08874 4C11.9556 4 14.9249 5.64103 16.256 8.92308C17.3823 5.84615 20.0444 4 23.5256 4C27.9283 4 31 7.79487 31 13.3333C31 19.4872 26.802 22.9744 22.3993 26.5641C20.4539 28.2051 18.5085 29.8462 16.6655 31.7949C16.5631 31.8974 16.3584 32 16.256 32Z"
          fill="currentColor"
        />
        <path
          d="M16.256 32C16.0512 32 15.8464 31.8974 15.744 31.7949C13.901 29.8462 11.8532 28.1026 9.90785 26.359C5.30034 22.5641 1 18.8718 1 13.2308C1 7.69231 4.17406 4 9.08874 4C11.9556 4 14.9249 5.64103 16.256 8.92308C17.3823 5.84615 20.0444 4 23.5256 4C27.9283 4 31 7.79487 31 13.3333C31 19.4872 26.802 22.9744 22.3993 26.5641C20.4539 28.2051 18.5085 29.8462 16.6655 31.7949C16.5631 31.8974 16.3584 32 16.256 32ZM9.08874 5.33333C4.99317 5.33333 2.33106 8.41026 2.33106 13.2308C2.33106 18.359 6.22184 21.641 10.727 25.4359C12.57 26.9744 14.413 28.6154 16.256 30.4615C17.9966 28.6154 19.8396 27.0769 21.5802 25.641C25.8805 22.0513 29.6689 18.8718 29.6689 13.4359C29.6689 9.4359 27.7235 5.4359 23.5256 5.4359C19.5324 5.4359 16.8703 8.30769 16.8703 12.8205C16.8703 13.2308 16.5631 13.4359 16.256 13.4359C15.9488 13.4359 15.6416 13.1282 15.6416 12.8205C15.5392 7.89744 12.2628 5.33333 9.08874 5.33333Z"
          fill="currentColor"
        />
      </svg>
    )
  },
)
